module.exports = __webpack_public_path__ + "static/media/buttinst.b8bbe845.png";